
import React, { memo } from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from "react-redux";

import * as actions from "../reducers/action-reducer"
import * as types from "../types";
import * as track from '../data/track/track'
var classnames = require("classnames");
import { Dialog, DialogTitle, DialogActions, DialogContent, DialogContentText, List, ListItem, ListItemText } from "@material-ui/core";
import Button from "src/components/CustomButtons/Button.jsx";

var uuid = require("uuid");
interface ErrorBoxProps {
    classes: any;
    connect: types.IState,
    showError:boolean;
}
interface ErrorBoxState {

}

let styles = {

}
class ErrorBox extends React.Component<ErrorBoxProps, ErrorBoxState> {
    constructor(props: ErrorBoxProps) {
        super(props);

        this.state = {
            copied:false

        };
       
    }


    async handleClose(e: any) {
        this.props.connect.dispatch(actions.closeErrorModal());
    }

    render() {
       // debugger;
        let show = this.props.connect.errorState.showError ;//|| (this.props.connect.errorState.lastError && this.props.connect.errorState.lastError.showModal);
        if (!show) {
            return <div />;
        }


        var errors = this.props.connect.errorState.errorArray.sort(
            (a: track.ErrorObj, b: track.ErrorObj) => {
                return a.timestamp > b.timestamp ? -1 : 1;
            }
        ).slice(0, 10);
        if (this.props.connect.errorState.lastError && this.props.connect.errorState.lastError.showModal) {
            errors = [this.props.connect.errorState.lastError];
        }
        function getErrorMessage(err)
        {
            if(err)
            {
                if(err.message)
                {
                    return err.message;
                }
                return err;
            }
            return undefined;
        }
        let Form = (
            <div className="container">
                <List>

                    {errors.map((x) => (
                        <ListItem alignItems="flex-start">

                            <ListItemText
                                primary={x.userMessage} secondary={getErrorMessage(x.exception)}
                            />
                        </ListItem>


                    ))}
                </List>
            </div>
        );

        return (
            <div id="hey">

                <Dialog

                    maxWidth="md"
                    open={show}

                    onClose={this.handleClose.bind(this)}
                    aria-labelledby="responsive-dialog-title"
                >
                    <DialogTitle id="responsive-dialog-title">Error</DialogTitle>
                    <DialogContent>

                        <div className='mobile-form-with-header'>
                            {Form}
                        </div></DialogContent>
                    <DialogActions>

                        <Button onClick={this.handleClose.bind(this)} simple color="primary" autoFocus>
                            Close
                            </Button>


                    </DialogActions>
                </Dialog>
            </div>
        );
    }


}


export function mapStateToProps(state: types.IState) {
    return {
        connect: state
    };
}
export default connect(
    mapStateToProps,
    null
)(withStyles(styles as any)(ErrorBox));


// WEBPACK FOOTER //
// ./src/custom_components/ErrorBox.tsx